import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  toggleButton1: classNames(
    '!mr-2',
    'capitalize',
  ),
  toggleButton2: classNames(
    'lowercase',
    'capitalize',
  ),
  packageType: classNames(
    'grid',
    'grid-cols-2',
    'gap-4',
  ),
  unitToggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
};

export default styles;
